import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadString,
  uploadBytesResumable,
} from "firebase/storage";
import { app } from "../../../../config/config";

const storage = getStorage(app);

// ------------------------ Media ------------------------
// upload media
export const uploadImg = async ({ path, file }) => {
  console.log({ path, file });
  const storageRef = ref(storage, path);
  try {
    await uploadBytes(storageRef, file);
    return true;
  } catch (error) {
    return false;
  }
};

// upload media strings
export const uploadString64 = ({ path, base64String }) => {
  const storageRef = ref(storage, path);
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "image/png" });
  return uploadBytes(storageRef, blob);
};

export const saveDataURLToStorage = ({ path, dataURL }) => {
  const storageRef = ref(storage, path);
  return uploadString(storageRef, dataURL, "data_url");
};

//get Url download
export const getUrlFromStorage = async ({ path }, callback) => {
  try {
    const storageRef = ref(storage, path);
    const url = await getDownloadURL(storageRef);
    console.log({ url });
    if (callback) {
      callback(url);
    }
    return url;
  } catch (error) {
    console.error(error);
    if (callback) {
      callback(null);
    }
  }
};

export const uploadCsv = async ({ file, doc }) => {
  const storageRef = ref(storage, doc);
  const uploadTask = uploadBytesResumable(storageRef, file);

  return uploadTask.on(
    "state_changed",
    (snapshot) => {
      return true;
    },
    (error) => {
      return false;
    }
  );
};

// get download url
export const getCsv =
  ({ href }, callback) =>
  (dispatch) => {
    const storageRef = ref(storage, href);
    getDownloadURL(storageRef)
      .then((url) => {
        if (url) {
          callback({ status: 200, data: url });
        }
      })
      .catch((err) => {
        callback({ status: 500, data: err?.message });
      });
  };
